export const getCountryList = async () => {
    const countryArray = [
        { name: "India", code: "IN" },
        { name: "Thailand", code: "TH" },
        { name: "Australia", code: "AU" },
        { name: "France", code: "FR" },
        { name: "Germany", code: "DE" },
        { name: "Japan", code: "JP" },
        { name: "Russia", code: "RU" },
        { name: "United States", code: "US" },
        { name: "China", code: "CN" },
        { name: "United Kingdom", code: "GB" },
    ];
    return countryArray;
};


export const getCountryCodeBasedOnCountry = async (value) => {
    const countryList = await getCountryList();
    const tempCountry = countryList.find((country) => (country.name).toLocaleLowerCase() === value.toLocaleLowerCase());

    if (!tempCountry) {
        return;
    }
    return tempCountry.code;
}